"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
function RadioInputDirective(config, $timeout) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/radio-input.html',
        controller: /** @class */ (function (_super) {
            __extends(RadioInputController, _super);
            function RadioInputController($scope, $element, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.element = $element;
                _this.custom = $scope.option.custom || false;
                _this.placeholder = $scope.option.placeholder;
                _this.pattern = $scope.option.pattern;
                _this.restrict = $scope.option.restrict;
                _this.setSingleCol(false);
                _this.form.value = book.getIndex(_this.prefix, _this.id, true);
                if (_this.form.value === $scope.$parent.$index) {
                    _this.value = _this.book.get(_this.prefix, _this.id);
                    if ($scope.option.restrict) {
                        _this.regexp = new RegExp('^' + $scope.option.restrict + '$');
                    }
                }
                return _this;
            }
            RadioInputController.prototype.onChange = function (index) {
                this.form.value = index;
                if (this.custom) {
                    if (typeof this.value === 'undefined' || this.regexp && !this.regexp.test(this.value)) {
                        this.value = this.book.get(this.prefix, this.id);
                    }
                    else {
                        this.book.update(this.prefix, this.id, this.form.value, this.value);
                    }
                    var input_1 = this.element[0].querySelector('input[type="text"]');
                    $timeout(function () { input_1.focus(); });
                }
                else {
                    this.book.update(this.prefix, this.id, this.form.value);
                }
            };
            return RadioInputController;
        }(form_1.FormOptionController)),
        controllerAs: 'radioInputCtrl'
    };
}
exports.RadioInputDirective = RadioInputDirective;
